<template>
    <div class="totem-completed-tag">
        <span class="icon-checkmark"></span>
        <span v-html="$t('TotemCompletedItem.completed')"></span> <span>{{ formattedDateForCountry(completedDate) }}</span>
    </div>
</template>

<script>
    import { formattedDateForCountry } from 'components/shared/mixins/dateHelper'
    import { mapGetters } from 'vuex'
    export default {
        name: 'totem-completed-tag',
        props: {
            course: {
                type: Object,
                required: true
            }
        },
        computed: {
            ...mapGetters({
                completedCourses: 'CompletedCourses/certificates'
            }),
            completedDate () {
                let completedCourse = this.completedCourses.courses.find(completedCourse => completedCourse.id === this.course.id)
                if (completedCourse) {
                    return completedCourse.certificate.certificationDate
                }
                return ''
            }
        },
        methods: {
            formattedDateForCountry
        }
    }
</script>

<style lang="scss">
    .totem-completed-tag {
        display: inline-flex;
        align-items: center;
        padding: 0 12px;
        margin: 0 6px 6px 0;
        border-radius: 3px;
        height: 22px;
        background: $bright_gray;
        position: relative;
        gap: 5px;
        font-size: 1.4rem;

        .icon-checkmark {
            color: $ocean-green;
        }
    }
</style>
